import { Flex, HStack, Text } from '@chakra-ui/react';
import React, { FC, useMemo } from 'react';
import { useGetBestBidForListing } from '@app/hooks/nft/useGetBestBidForListing';
import { NFTMarketplaceListing } from '@app/types/nftMarketplace';
import { AUCTION_TYPES } from '@app/constants/nftMarketplace';
import { Token } from '@app/types/token';
import { calculateDiscountOrPremium } from '@app/helpers/calculateDiscountOrPremium';
import { formatUnits } from 'ethers/lib/utils';

type Props = {
  currency: Token;
  listing: NFTMarketplaceListing;
  deposit: number | null;
};

export const DiscountCell: FC<Props> = ({ currency, listing, deposit }) => {
  const { data } = useGetBestBidForListing(listing.id);

  const value = useMemo(() => {
    if (
      listing.type !== AUCTION_TYPES.ENGLISH_AUCTION &&
      listing.type !== AUCTION_TYPES.BUY_IT_NOW_WITH_BIDS
    ) {
      return formatUnits(listing.price, currency.decimals);
    }

    if (!data) {
      return null;
    }

    const parsedAmount = data.amount?.toString() ?? 0;

    return formatUnits(
      parsedAmount && parsedAmount !== '0' ? parsedAmount : listing.reserve,
      currency.decimals
    );
  }, [data, listing, currency]);

  const diff = calculateDiscountOrPremium(deposit, value);

  return (
    <Flex alignItems="center">
      {diff < 0 && (
        <HStack w="100%">
          <Text fontSize="14px" fontWeight="400" color="success">
            {Math.abs(diff).toFixed(2)}%
          </Text>
        </HStack>
      )}
      {diff > 0 && (
        <HStack w="100%">
          <Text fontSize="14px" fontWeight="400" color="error">
            {diff.toFixed(2)}%
          </Text>
        </HStack>
      )}
      {diff === 0 && (
        <HStack w="100%">
          <Text fontSize="14px" fontWeight="400" color="neutral.400">
            -
          </Text>
        </HStack>
      )}
    </Flex>
  );
};
